
<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.EDIT_PRICE_LIST' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" routerLink="/export/integrations/kaspi">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="sendContent()" [disabled]="selectedOffers.length == 0 || form.invalid || loading">
                        <i class="bi bi-cloud-upload"></i> {{ 'INTEGRATION.SUBMIT_CONTENT' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="addOffer()">
                        <i class="bi bi-plus-circle"></i> {{ 'INTEGRATION.ADD_ELEM' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onUpdate()" [disabled]="form.invalid || loading">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="row chb-main">
                    <div class="col-12 checkbox">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" name="select_all" id="select_all" [checked]="isAllCheckBoxChecked()" [indeterminate]="checkedButNotAllCheckBox()" (change)="checkAllCheckBox($event)">
                            <label class="custom-control-label" for="select_all">{{ 'INTEGRATION.SELECT_ALL' | translate }}</label>
                        </div>
                    </div>
                </div>

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div formArrayName="offers">
                        <div *ngFor="let offer of form.get('offers')['controls']; let i = index;">
                            <div [formGroupName]="i" class="row offer-item">

                                <div class="col-3">
                                    <div class="first-field">
                                        <div class="checkbox">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" name="select_{{ i }}" id="select_{{ i }}" [disabled]="offers[i].id == null" [checked]="offers[i].checked" (change)="selectedCheckBox(i, $event)">
                                                <label class="custom-control-label" for="select_{{ i }}"></label>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="product_id_{{i}}"><span class="star">*</span> {{ 'PRODUCT.PRODUCTS_LIST' | translate }}</label>
                                            <ng-select 
                                                id="product_id_{{i}}" 
                                                class="custom" 
                                                clearAllText="{{ 'CLEAR' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="id"
                                                formControlName="product_id"
                                                [loading]="loading"
                                                [items]="products"
                                                (search)="getProducts($event.term, 'search')"
                                                (change)="getProducts('', 'change')"
                                                (open)="getProducts('', 'open')">
                                            </ng-select>
                                            <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.product_id">
                                                    <div class="text-error" *ngIf="validation(['offers', i, 'product_id'], item.type)">
                                                        {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <select class="form-control" id="product_id_{{i}}" formControlName="product_id">
                                                <option *ngFor="let product of products" [value]="product.id">{{ product.name }}</option>
                                            </select> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="price_{{i}}" class="label"><span class="star">*</span> {{ 'PRICE.PRICE' | translate }}</label>
                                        <input type="text" class="form-control" id="price_{{i}}" formControlName="price" mask="separator">
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.price">
                                                <div class="text-error" *ngIf="validation(['offers', i, 'price'], item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-5">

                                    <div class="row">
                                        <div class="col-12">
                                            <label class="label"><span class="star">*</span> {{ 'INTEGRATION.AVAILABILITY' | translate }}</label>
                                        </div>
                                        <div class="col-1">
                                            <button type="button" class="btn btn-primary btn-sm" (click)="addAvailability(i)">
                                                <i class="bi bi-plus-circle"></i>
                                            </button>
                                        </div>
                                        <div class="col-11 availabilities-box">
                                            <ul class="availabilities-list" formArrayName="availabilities">
                                                <li class="availabilities-item" *ngFor="let availability of offer.get('availabilities')['controls']; let j = index;">
                                                    <div class="availabilities-tag" [formGroupName]="j">
                                                        {{ availability.get('storeId').value }}: <span *ngIf="availability.get('available').value == 'yes'"> {{ 'YES' | translate }}</span>
                                                        <div class="availabilities-tag-btn-remove" (click)="removeAvailability(i, j)" *ngIf="j > 0 && (j+1) == offer.get('availabilities').value.length">
                                                            <i class="bi bi-x-circle"></i>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-1 offer-btn-box">
                                    <button 
                                        *ngIf="form.get('offers').value.length > (i+1)"
                                        type="button"
                                        class="btn btn-danger btn-sm"
                                        (click)="removeOffer(i)">
                                            <i class="bi bi-x-circle"></i>{{ 'DELETE' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>

                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>

            </div>

        </div>

    </div>
</div>